<template>
  <div class="py-3">
    <div class="space-y-2.5">
      <UiNativeSelect
        select-class="material-select-view-select text-white bg-transparent border border-black-60 appearance-none"
        :model-value="internalValue"
        :items="takeOutField(block.materials, 'title')"
        value-key="sku"
        title-key="title"
        :name="block.slug"
        :label="`${title}`"
        :label-class="`${labelClass} font-normal`"
        :placeholder="$t('selectOptionPlaceholder', { name: title })"
        @update:modelValue="onUpdate"
      />
    </div>
    <slot name="additional" />
  </div>
</template>

<script setup lang="ts">
import {
  IProductMaterialFilterEvent,
  IProductMaterialFilterProps,
} from "ecom-types";
import { sizesSlugs } from "~/configs";

const props = defineProps<IProductMaterialFilterProps>();

const emit = defineEmits<{
  (e: "filter", value: IProductMaterialFilterEvent): void;
}>();

const route = useRoute();

const isDefaultSize = computed(() => {
  return route.query.size === "default";
});

const isSize = computed(() => {
  return sizesSlugs.includes(props.block.slug);
});

const internalValue = computed(() => {
  if (isSize.value) {
    return (!isDefaultSize.value && props.selectedItem?.sku) || "";
  } else {
    return props.selectedItem?.sku || "";
  }
});

function onUpdate(value: string) {
  const currentItem = props.block.materials.find(
    (material) => material.sku === value,
  );

  onFilterClick(props.block.slug, currentItem);
}

function takeOutField(items: MaterialData[], field: string) {
  return items.map((el) => ({
    ...el,
    [field]: el.currentTranslation?.[field],
  }));
}

function onFilterClick(slug: string, item?: MaterialData) {
  emit("filter", { slug, item });
}
</script>

<style>
select.material-select-view-select {
  background-image: url("~/assets/icons/so-arrow-white-dropdown.svg");
  background-size: 0.85em 0.85em;
  background-repeat: no-repeat;
}
</style>
